import { render, staticRenderFns } from "./EtapaEscalas.vue?vue&type=template&id=43dcc54e&scoped=true"
import script from "./EtapaEscalas.vue?vue&type=script&lang=js"
export * from "./EtapaEscalas.vue?vue&type=script&lang=js"
import style0 from "./EtapaEscalas.vue?vue&type=style&index=0&id=43dcc54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dcc54e",
  null
  
)

export default component.exports